module.exports = __webpack_public_path__ + "static/media/use7.94c7ef7e.jpeg";